import { documentNumberPrefix, nextDocumentNumber } from "helpers/validators";

export const defaultFormData = {
    infoBasePrefix: "00",
    organizationPrefix: "00",
    nextNumber: "1",
};

export const prefixAllowedCharsRegExp = /[^0-9A-Za-zА-Яа-яЁё]/gu;

export const buildPreview = (formData) =>
    `${formData.infoBasePrefix}${formData.organizationPrefix}-${String(Number(formData.nextNumber) || 0).padStart(6, "0")}`;

export const documentNumberSettingsConfig = {
    infoBasePrefix: {
        label: "Префикс инфобазы",
        inputProps: {
            name: "infoBasePrefix",
            maxLength: 2,
            placeholder: defaultFormData.infoBasePrefix,
            autoComplete: "off",
            pattern: "[0-9A-Za-zА-Яа-яЁё]{2}",
        },
        validators: [documentNumberPrefix],
        required: true,
    },
    organizationPrefix: {
        label: "Префикс организации",
        inputProps: {
            name: "organizationPrefix",
            maxLength: 2,
            placeholder: defaultFormData.organizationPrefix,
            autoComplete: "off",
            pattern: "[0-9A-Za-zА-Яа-яЁё]{2}",
        },
        validators: [documentNumberPrefix],
        required: true,
    },
    nextNumber: {
        label: "Следующий номер",
        inputProps: {
            name: "nextNumber",
            maxLength: 6,
            placeholder: defaultFormData.nextNumber,
            inputMode: "numeric",
            pattern: "[0-9]{1,6}",
            autoComplete: "off",
        },
        validators: [nextDocumentNumber],
        required: true,
    },
};

export const initialState = { ...defaultFormData };
